import React from 'react';
import './App.css';
import Main from './Main';
import { useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from './components/Header/Header';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  createMuiTheme,
  ThemeProvider,
  jssPreset,
  StylesProvider,
} from '@material-ui/core';
import { create } from 'jss';
import rtl from 'jss-rtl';

// Configure JSS to flip the Material UI layouts
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

function App() {
  useEffect(() => {
    toast.configure();
  }, []);

  const theme = createMuiTheme({
    direction: 'rtl',
    typography: {
      fontFamily: [
        'Droid Arabic Kufi',
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
    },
  });

  const RTL: React.FC<any> = (props) => {
    return <StylesProvider jss={jss}>{props.children}</StylesProvider>;
  };

  return (
    <RTL>
      <ThemeProvider theme={theme}>
        <ToastContainer />
        <Header />
        <div className="App">
          <Main />
        </div>
      </ThemeProvider>
    </RTL>
  );
}

export default App;
